














































































import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import { EUserPermissionsCategory, IUserPermissionItem } from '@/interfaces'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { USER_PERMISSIONS_LIST } from '@/constants'
import Icon from '@/components/Icon.vue'
import { EUserPermissions, IUserRolePermission } from '@zunta/configurations'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import ScrollView from '@/components/ScrollView.vue'

@Component({
  components: { ScrollView, InputV2, Icon, Checkbox, ModalV2 },
  props: {
    value: {
      type: Array as PropType<Array<EUserPermissions>>,
      required: true
    },
    role: {
      type: Number,
      required: true
    }
  }
})
export default class PermissionsModal extends Vue {
  localValue: any[] = []
  search: string = ''
  openedSections: string = EUserPermissionsCategory.FACILITY

  get permissionsCategories () {
    return Object.values(EUserPermissionsCategory)
  }

  get permissionsList () {
    return this.$store.state.permissions.permissions
  }

  get selectedRolePermissions () {
    return this.permissionsList
      .filter((permission: IUserRolePermission) => permission.role === this.$props.role)
  }

  get permissionsItemsList () {
    return USER_PERMISSIONS_LIST
      .filter((permissionItem: IUserPermissionItem) =>
        !!this.selectedRolePermissions
          .find((permission: IUserRolePermission) => permission.permission === permissionItem.permission)
      )
  }

  get permissionsByCategory () {
    return (cat: string): IUserPermissionItem[] =>
      this.permissionsItemsList
        .filter((item: IUserPermissionItem) => cat === item.category && item.description.toLowerCase().includes(this.search.toLowerCase()))
        .map((item: IUserPermissionItem) => {
          const strStartIndex: number = item.description.toLowerCase().search(this.search.toLowerCase())
          const highDesc: string =
            item.description.slice(0, strStartIndex) +
            '<mark>' + item.description.slice(strStartIndex, strStartIndex + this.search.length) + '</mark>' +
            item.description.slice(strStartIndex + this.search.length, item.description.length)
          return {
            ...item,
            description: highDesc
          }
        })
  }

  mounted () {
    this.localValue = this.$props.value
    this.$watch('value', (newValue) => {
      this.localValue = newValue
    })
  }

  isChecked (permissionItem: IUserPermissionItem) {
    if (!this.localValue) {
      return false
    }

    return !!this.localValue.find((permission: EUserPermissions) => (
      permission === permissionItem.permission
    ))
  }

  toggleCategory (cat: string) {
    if (this.openedSections === cat) {
      this.openedSections = ''
      return
    }

    this.openedSections = ''
    setTimeout(() => (this.openedSections = cat), 300)
  }

  togglePermission (permission: IUserPermissionItem, value: any) {
    if (value) {
      this.localValue.push(permission.permission)
    } else {
      this.localValue = this.localValue.filter((item: EUserPermissions) => permission.permission !== item)
    }
  }

  save () {
    this.$emit('input', this.localValue)
    this.$emit('close')
  }
}
